import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";

import { Wrapper } from "./Form.styles";
import WorkItemFormSection from "./Section";
import WorkItemFormFooter from "./Footer";

const WorkItemForm = props => {
  const {
    sections,
    showFooter,
    nextSection,
    redirectBack,
    ...restProps
  } = props;

  if (redirectBack) return <Redirect to="/" />;

  const footer = nextSection ? (
    <WorkItemFormFooter data-wi-footer {...props} />
  ) : null;

  return (
    <Wrapper>
      {sections.map((sProps, i) => {
        if (sProps.header === "Additional Information") {
          return nextSection ? (
            <WorkItemFormSection key={i} {...sProps} {...restProps} />
          ) : null;
        } else {
          return <WorkItemFormSection key={i} {...sProps} {...restProps} />;
        }
      })}

      {footer}
    </Wrapper>
  );
};

WorkItemForm.propTypes = {
  sections: PropTypes.array,
  showFooter: PropTypes.bool,
  nextSection: PropTypes.bool,
  redirectBack: PropTypes.bool
};

WorkItemForm.defaultProps = {
  sections: [],
  showFooter: true,
  nextSection: false,
  redirectBack: false
};

export default WorkItemForm;
